// extracted by mini-css-extract-plugin
module.exports = {"tablePreview":"styles_tablePreview__3eup1","tableParent":"styles_tableParent__2mZCb","limitHeight":"styles_limitHeight__2LYw5"};